import { render, staticRenderFns } from "./TermsOfServices.vue?vue&type=template&id=9a37d18e&"
import script from "./TermsOfServices.vue?vue&type=script&lang=ts&"
export * from "./TermsOfServices.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports